const resourcesRu = {
  translation: {
    Account: 'Учетная запись',
    AccountOptions: 'Параметры учетной записи',
    AirTemperature: 'Температура воздуха',
    Alarm: 'Тревога',
    AlarmMessage: 'Тревога получена',
    Analytics: 'Аналитика',
    AncDepth: 'Глубина якорной стоянки',
    Anchorage: 'Якорная стоянка',
    Anchorages: 'Якорные стоянки',
    Anchoring: 'Постановка на якорную стоянку',
    AnchoringOrRemove: 'Постановка/снятие с якоря на стоянке',
    AnyAnchorage: 'Любая якорная стоянка',
    AnyArea: 'Любая геозона',
    AnyPort: 'Любой порт',
    AnyVessel: 'Любое судно',
    APIKey: 'API-key',
    AppliedFilters: '(с учетом фильтров)',
    Apply: 'Применить',
    Area: 'Геозона',
    Areas: 'Геозоны',
    AreasArea: 'Площадь',
    AreasVesselsAmount: 'Судов в геозоне',
    AreaVesselsTotal: 'Судов в геозоне',
    AtAnchorage: 'Зашло на якорную стоянку',
    ATBA: 'Зоны повышенного риска (ATBA)',
    ATD: 'ATD',
    Aton: 'Средство навигации',
    AtonDescription: 'СНО (AtoN)',
    AtonInfo: 'Информация об атоне',
    Atons: 'Средства навигации',
    AtonsPageHeader: 'Средства навигации',
    AuthButtonLabel: 'Авторизоваться',
    AverageSpeed: 'Средняя скорость',
    AverageSpeedForMonth: 'Средняя скорость за 30 дней',
    AverageSpeedOnTheMoveForMonth: 'Средняя скорость (в движении) за 30 дней',
    BboxVesselsTotal: 'Судов в квадрате',
    BeachMoor: 'Пляжная швартовка',
    BreakBulk: 'Навалочные грузы',
    ButtonLabelAdd: 'Добавить',
    ButtonLabelAddVessel: 'Добавить судно',
    ButtonLabelAddVesselToFleet: 'Добавить во флот',
    ButtonLabelClose: 'Закрыть',
    ButtonLabelCreate: 'Создать',
    ButtonLabelDelete: 'Удалить',
    ButtonLabelDiscard: 'Отмена',
    ButtonLabelDownloadHistory: 'Скачать историю движения',
    ButtonLabelExportCSV: 'Экспорт CSV',
    ButtonLabelExportSCV: 'Экспорт CSV',
    ButtonLabelImport: 'Импортировать',
    ButtonLabelImportSCV: 'Импорт CSV',
    ButtonLabelSave: 'Сохранить',
    ButtonLabelToDiscard: 'Отменить',
    Calculate: 'Рассчитать',
    CalculatedETA: 'ETA \u2013 расчет',
    CallSign: 'Позывной',
    CargoDepth: 'Наибольшая глубина грузового причала',
    CargoFacilities: 'Виды грузов',
    CatalogAtonsTotal: 'Атонов в каталоге',
    CatalogPortsTotal: 'Портов в каталоге',
    CatalogVesselsTotal: 'Судов в каталоге',
    ChangesSaved: 'Изменения сохранены',
    ChannelDepth: 'Контрольная глубина канала',
    CheckboxLabelAllCountry: 'Все страны',
    CheckboxLabelAllFleetGroup: 'Все суда и группы',
    CheckboxLabelAllStatus: 'Все навигационные статусы',
    CheckboxLabelAllType: 'Все типы',
    CheckCorrectnessAddress: 'Проверьте правильность введенного адреса и попробуйте обратиться к странице еще раз',
    ChooseFile: 'Выберите файл',
    ChosenVessel: 'Заданное судно',
    Cht: 'Утилизация содержимого химических резервуаров',
    ClipboardCopy: 'Скопировать в буфер обмена',
    ClipboardCopySuccess: 'Значение скопировано в буфер обмена',
    CollapseSidebar: 'Свернуть меню',
    Color: 'Цвет',
    CommonAreasTitle: 'Системные геозоны',
    CommonAreaTitle: 'Системная геозона',
    ConstructionAndOperation: 'Постройка и эксплуатация',
    ConstructionDateFilter: 'Суда с годом постройки',
    Contaiiner: 'Контейнеры',
    Coordinates: 'Координаты',
    CoordinatesFormatOption: 'Формат координат',
    Country: 'Страна',
    Course: 'Курс',
    CreateNotification: 'Создайте уведомление',
    CreationYear: 'Год постройки',
    CurrentPosition: 'Текущее положение',
    DangCargoAncor: 'Якорная стоянка для опасных грузов',
    DataIsLoading: 'Загрузка данных',
    DataNotObtained: 'Данные не получены',
    DataObtained: 'Данные получены',
    DataSourceLabel: 'Источник данных',
    Date: 'Дата',
    DatePickerLabel: 'Дата, время:',
    DatePickerPlaceholderText: 'Выбрать дату',
    DatePickerTimeCaption: 'Время',
    Day: 'День',
    DaysOnTheMove: 'Дней в движении',
    DaysOnTheMoveSubValue: 'из 30',
    DeadWeight: 'Валовая грузоподъемность',
    DegreesUnit: 'град',
    DepartureFromPort: 'Отправление из порта',
    DeparturePort: 'Порт отправления',
    Depth: 'Высота борта',
    Description: 'Описание',
    Design: 'Конструкция',
    Destination: 'Пункт назначения',
    DestinationAis: 'Назначение – АИС',
    DestinationPortKeyFilter: 'Суда направляющиеся в',
    DirtyBall: 'Утилизация грязного балласта',
    Displacement: 'Водоизмещение',
    Distance: 'Дистанция',
    Distances: 'Расстояния',
    DownloadReport: 'Скачать отчёт',
    Draught: 'Текущая осадка',
    ECA: 'Зоны контроля выбросов (ECA)',
    Editor: 'Редактор',
    EEZ: 'Исключительная экономическая зона (EEZ)',
    EgisPageTitle: 'СИТРОНИКС.ГИС',
    EmergencySignals: 'Аварийные сигналы',
    EnglishLanguage: 'English (EN)',
    EnteredTheGeozone: 'Вход в геозону',
    EnteredYearError: 'Введенное значение должно быть в пределах от 0 до ',
    EntranceRestriction: 'Ограничения на вход',
    EntranceWidth: 'Ограничения по ширине входа',
    Error_IsRequired: 'Обязательно для заполнения',
    Error_NineDigits: 'Значение должно содержать 9 цифр',
    Error_OnlyNumbers: 'Должно содержать только цифры',
    ErrorOperationOfService: 'Ошибка в работе сервиса',
    ETA: 'ETA \u2013 АИС',
    EtaFilterLabel: 'Дата прибытия',
    EtaPlanned: 'ETA (план)',
    EventDate: 'Дата события',
    EventType: 'Тип события',
    Feedback: 'Обратная связь',
    FieldPlaceholderGroupDescription: 'Введите описание группы',
    FieldPlaceholderGroupName: 'Введите имя группы',
    FieldPlaceholderMMSI: 'MMSI (9 цифр)',
    FilesReview: 'Обзор...',
    FileUploadTitleCSV: 'Выберите файл в формате CSV, содержащий список судов',
    Filter: 'Фильтр...',
    FilterPanelButtonReset: 'Сбросить фильтры',
    FilterPanelButtonSubmit: 'ОК',
    FilterPanelHeading: 'Фильтры',
    FilterPanelLabelCountries: 'Страны',
    FilterPanelLabelFleetGroup: 'Флот и группы судов',
    FilterPanelLabelFleetOnly: 'Только флот',
    FilterPanelLabelStatus: 'Навигационные статусы',
    FirstPort: 'Таможенная и карантинная очистка',
    Flag: 'Флаг',
    FleetLabel: 'Флот',
    FleetVesselsTotal: 'Судов во флоте',
    ForTheGeozone: 'Для геозоны',
    ForThePort: 'Для порта',
    ForTheVessel: 'Для судна',
    From: 'Откуда',
    FromAsLimit: 'От',
    FromToValueError: 'Значение "от" не может превышать значение "до"',
    FuelBunker: 'Запасы топлива',
    FuelType: 'Тип топлива',
    GarbageDisp: 'Утилизация мусора',
    GeofenceName: 'Название геозоны',
    GeofenceNamePlaceholder: 'Введите название геозоны',
    GeofenceRemoved: 'Геозона удалена',
    GeofenceRemoving: 'Удаление геозоны',
    GeofenceRemovingDescription: `Геозона «{{name}}» будет удалена.\nТакже автоматически удалятся ранее созданные подписки на уведомления по этой зоне.\nВосстановить удаленную зону, а также подписки нельзя.\nПри необходимости создайте зону и подписки на уведомления заново.`,
    GeofenceRemovingQuestion: 'Удалить геозону «{{name}}»?',
    GeofenceWktLabel: 'Координаты (WKT)',
    GeofenceWktPlaceholder: 'Введите координаты в формате WKT',
    GlobalSearchPlaceholder: 'Введите данные для поиска',
    GoToTGBotPhrase: 'Перейти в телеграм бот по ссылке',
    GrossLoad: 'Текущая загрузка',
    GrossTonnage: 'Валовая вместимость',
    GrossTonnageUnit: 'рт',
    Group: 'Группа',
    GroupParametrs: 'Параметры группы',
    Groups: 'Группы',
    GyroCompass: 'Гирокомпас',
    Harbor: 'Гавань',
    HarborSize: 'Размер гавани',
    HarborType: 'Тип гавани',
    HarborUse: 'Назначение гавани',
    HideWeather: 'Скрыть данные о погоде',
    History: 'История',
    HistoryData: 'Исторические данные',
    Home: 'Начало',
    HomePort: 'Порт приписки',
    HoverTextAverageSpeedOnTheMove: 'Скорость только во время движения судна',
    HoverTextAverageSpeedTotal: 'Скорость с учетом периодов простоя в портах, на якорных стоянках и т.п.',
    IceClass: 'Ледовый класс',
    IceMoor: 'Ледовая швартовка',
    IMO: 'IMO',
    InactiveTag: '(неактивен)',
    IncorrectCSVFileFormatError: 'Файл неверного формата. Поддерживаемый формат - CSV',
    IncorrectGeofenceNameLenghtError: 'Название геозоны должно содержать от 1 до 256 символов',
    IncorrectGeofenceWKTError: 'Некорректный формат координат',
    IncorrectGroupNameLenghtError: 'Название должно содержать от 1 до 64 символов',
    IncorrectHeadingOrCogValueError: 'Введенное значение должно быть в пределах от 0 до 360',
    IncorrectShipNoteLenghtError: 'Заметка должна содержать до 256 символов',
    Info: 'Инфо',
    Inmarsat: 'Инмарсат',
    InPortKeyFilter: 'Суда в порту',
    InTotal: 'Итого',
    InvalidLatitude: 'Неверная широта',
    Km: 'км',
    KmH: 'км/ч',
    Language: 'Язык',
    LastPosition: 'Последняя позиция',
    Latitude: 'Широта',
    Layers: 'Слои',
    LeftAnchorage: 'Вышло из якорной стоянки',
    LeftTheGeozone: 'Выход из геозоны',
    LengthBeam: 'Длина / ширина',
    LengthDimension: 'Длина',
    Less: 'Меньше',
    LessThenHour: 'менее часа',
    LiquidBulk: 'Наливные грузы',
    LLZ: 'Зоны грузовой марки (LLZ)',
    LngTerm: 'Терминал СПГ',
    LoadMore: 'Загрузить еще',
    LocalTime: 'Местное время',
    Login: 'Имя пользователя',
    Logout: 'Выйти',
    Longitude: 'Долгота',
    LowerTheAnchor: 'Прибытие',
    LukoilPageTitle: 'Спутниковый мониторинг',
    MainEngine: 'Количество и мощность главных двигателей',
    Map: 'Карта',
    MarketPlaceLabel: 'Спутниковые снимки',
    MaximumDraft: 'Максимальная осадка',
    MedFacili: 'Медицинская служба',
    MedMoor: 'Средиземноморская швартовка',
    MeterUnit: 'м',
    MinZeroValueError: 'Значение должно быть больше или равно 0',
    MinZoomTitle: 'Общий обзор карты',
    MMSI: 'MMSI',
    ModalAddToFleetLabel: 'Чтобы добавить судно в состав флота введите его MMSI:',
    ModalDeleteFromFleetQuestion: 'Удалить из списка флота?',
    ModalDeleteNtfRuleQuestion: 'Удалить?',
    ModalDeleteNtfRulesQuestion: 'Удалить {{length}}?',
    ModalTitleAddToFleet: 'Добавление судна в состав флота',
    ModalTitleDeleteFromFleet: 'Удаление флота',
    ModalTitleDeleteNtfRule: 'Удаление подписки',
    ModalTitleImportToFleet: 'Импорт списка судов из файла',
    Month: 'Месяц',
    Mooring: 'Виды швартовки',
    More: 'Больше',
    MotionlessVessel: 'Судно без движения',
    Name: 'Название',
    NauticalChart: 'Морская карта',
    NavStatus: 'Нав. статус',
    NearbyShips: 'Суда рядом',
    NeedToAuth: 'Для продолжения работы необходимо авторизоваться.',
    NewGeofence: 'Новая геозона',
    NewGroupName: 'Новая группа',
    NewNotificationRule: 'Новое уведомление',
    NM: 'ММ',
    NoFile: 'Нет файла',
    NoGroup: 'Нет группы',
    NoNotificationRules: 'Подписок нет',
    NoNotifications: 'Нет уведомлений',
    NoPhoto: 'Нет фото',
    NoPlayBackData: 'Недостаточно данных для отображения, выберите другую дату.',
    NoPlaybackVesselData: 'Недостаточно данных для отображения.',
    NoResultsFound: 'Результаты не найдены',
    Notes: 'Заметки',
    NotFoundPage: '404: Страница не найдена',
    Notification: 'Уведомление',
    NotificationDelivery: 'Доставка уведомлений',
    Notifications: 'Уведомления',
    NotificationSettings: 'Параметры уведомления',
    NotificationsList: 'Журнал',
    NotificationsSettings: 'Настройка',
    Notify: 'Оповестить',
    NoVesselsInFleet: 'В списке нет судов, пожалуйста добавьте MMSI.',
    Objects: 'Объекты',
    OilTerm: 'Нефтяной терминал',
    OilTermDepth: 'Наибольшая глубина нефтяного терминала',
    Others: 'Другие',
    Owner: 'Владелец',
    Perimeter: 'Периметр',
    Period: 'Период',
    Photo: 'Фото',
    Port: 'Порт',
    PortArrival: 'Прибытие в порт',
    PortArrivalsDateOption_24h: '24 часа',
    PortArrivalsDateOption_30d: '30 дней',
    PortArrivalsDateOption_48h: '48 часов',
    PortArrivalsDateOption_72h: '72 часа',
    PortEvents: 'Судозаходы',
    PortInfo: 'Информация о порте',
    PortSecur: 'Безопасность в порту',
    PortsPageHeader: 'Порты',
    PortTargetCatalog: 'Суда в порту',
    PortTerminal: 'Портовый терминал',
    PortVesselsTotal: 'Судов в порту',
    Position: 'Позиция',
    PowerPlantType: 'Тип силовой установки',
    PredictedPort: 'Порт (возможно)',
    PreferredSettings: 'Вывод данных',
    Pressure: 'Давление',
    PressureHumidity: 'Давление, влажность',
    PressureHumidityFull: 'Атм.давление, влажность',
    PressureUnit: 'мм рт. ст.',
    PropellerInfo: 'Информация о движителях',
    Proportion: 'Доля',
    Platform: 'Платформа',
    RaiseTheAnchor: 'Убытие',
    Registration: 'Регистрация',
    Registry: 'Регистр',
    RegistryNumber: 'Регистровый номер',
    ReloadOrSupport: 'Попробуйте перезагрузить страницу или обратитесь в службу поддержки',
    RemovingFromAnchorage: 'Снятие с якорной стоянки',
    ResourceIsTemporarilyUnavailable: 'Ресурс временно недоступен',
    RestrIce: 'Ограничение на вход (лед)',
    RestrOther: 'Ограничение на вход (другое)',
    RestrSwell: 'Ограничение на вход (волны)',
    RestrTide: 'Ограничение на вход (прилив)',
    Roro: 'Ро-ро',
    RouteBuilderWarning: 'Маршрут для справки. Без контроля точности прокладки не использовать',
    RulesWillBeDeleted:
      'Подписки будут удалены. Восстановить удаленную подписку нельзя. При необходимости создайте подписку заново',
    RuleWillBeDeleted:
      'Подписка будет удалена. Восстановить удаленную подписку нельзя. При необходимости создайте подписку заново',
    RussianLanguage: 'Русский (RU)',
    SatelliteView: 'Спутник',
    SearchingText: 'Идет поиск',
    SearchPlaceholder: 'Поиск',
    SelectAllVessels: 'Выбрать все суда',
    SelectArea: 'Выберите геозону',
    SelectPort: 'Выберите порт',
    SelectVessel: 'Выбор судна',
    Service: 'Услуги в порту',
    SettingLabelAutoRefresh: 'Обновлять карту автоматически',
    SettingLabelShowGroupIndicator: 'Выделять группы флота',
    SettingLabelShowLegend: 'Легенда',
    SettingLabelShowPorts: 'Порты',
    SettingLabelShowRoutePredicted: 'Прогнозируемый путь',
    SettingLabelShowRoutes: 'Пройденный путь',
    SettingLabelShowTerminals: 'Терминалы',
    SettingLabelShowVessels: 'Суда',
    Settings: 'Настройки',
    SeveralGroup: 'Несколько групп',
    Shipbuilder: 'Судостроитель',
    ShipNote: 'Заметки',
    ShipTypesLabel: 'Типы судов',
    ShowBboxVesselsTitle: 'Суда на карте',
    ShowFiltersTitle: 'Показать фильтры',
    ShowOnMap: 'Показать на карте',
    ShowRoute: 'Пройденный путь',
    ShowRoutePredicted: 'Прогнозируемый путь',
    ShowSettingTitle: 'Настройки отображения',
    SiAISBot: 'СиАИС Бот',
    SimbolOfClass: 'Символ класса',
    SimilarShips: 'Похожие суда',
    SogFilter: 'Суда со скоростью',
    SolidBulk: 'Твердые грузы',
    Source: 'Источник',
    SourceDescriptionSatellite: 'Cпутниковый АИС (S-AIS)',
    SourceDescriptionTerrestrial: 'Береговой АИС (T-AIS)',
    SpecialAreasTitle: 'Особые геозоны',
    SpecifiedArea: 'Заданная геозона',
    SpecifiedPort: 'Заданный порт',
    Speed: 'Скорость',
    SpeedPastTrack: 'Скорость (пройденный путь)',
    SubscriptionTelegramNotificationsDisabled: 'Подписка на уведомления в Телеграм отключена',
    SubscriptionTelegramNotificationsEnabled: 'Подписка на уведомления в Телеграм включена',
    SunriseSunset: 'Восход, закат',
    Support: 'Техническая поддержка',
    Telegram: 'Telegram',
    TelegramNotificationWarning: 'Подпишитесь на telegram бот. Сейчас уведомления выключены',
    Temperature: 'Температура',
    Terminal: 'Терминал',
    Terminals: 'Терминалы',
    TerminalTargetCatalog: 'Суда в терминале',
    TerminalVesselsTotal: 'Судов в терминале',
    TheLatestMotionDate: 'Дата последнего движения',
    TidalRange: 'Максимальная разница при приливе и отливе',
    TimeFormatOption: 'Формат времени',
    TimeOnRoute: 'Время в пути',
    TimeZoneOption: 'Часовой пояс',
    To: 'Куда',
    ToAsLimit: 'До',
    Token: 'Токен',
    TonnageUnit: 'т',
    Total: 'Всего',
    TrackedSince: 'Дата первой полученной позиции',
    TransponderClass: 'Класс транспондера',
    TravelledForDay: 'Пройдено за 24 часа',
    TravelledForMonth: 'Пройдено за 30 дней',
    Type: 'Тип',
    UserAreasTitle: 'Личные геозоны',
    UserAreaTitle: 'Личная геозона',
    UserSettingsDeliveryStatusConfigured: 'Настроен',
    UserSettingsDeliveryUnsubscribe: 'Отписаться',
    VectorMap: 'Карта',
    Vessel: 'Судно',
    VesselBeam: 'Максимально допустимая ширина судна',
    VesselCalls: 'Судозаходы',
    VesselCallsExpected: 'Ожидаются судозаходы',
    VesselDraft: 'Максимально допустимая осадка судна',
    VesselInfo: 'Информация о судне',
    VesselLength: 'Максимально допустимая длина судна',
    VesselPlayback: 'Воспроизведение пути следования',
    VesselsInArea: 'Суда в геозоне',
    VesselsNames: 'Названия судов',
    VesselsPageHeader: 'Суда',
    VesselSpeedUnit: 'уз',
    VesselsWillBeDeleted: 'Будет удалено: {{amount}}',
    VesselTerminal: 'Терминал',
    VesselTypeCargo: 'Грузовое судно',
    VesselTypeCargoPlural: 'Грузовые суда',
    VesselTypeFishing: 'Рыболовецкое судно',
    VesselTypeFishingPlural: 'Рыболовецкие суда',
    VesselTypeOther: 'Прочие суда',
    VesselTypePassenger: 'Пассажирское судно',
    VesselTypePassengerPlural: 'Пассажирские суда',
    VesselTypePleasure: 'Прогулочное судно',
    VesselTypePleasurePlural: 'Прогулочные суда',
    VesselTypeSpecialTug: 'Спец. судно, буксир',
    VesselTypeSpecialTugPlural: 'Спец. суда, буксиры',
    VesselTypeSpeed: 'Скоростное судно',
    VesselTypeSpeedPlural: 'Скоростные суда',
    VesselTypeTanker: 'Танкер',
    VesselTypeTankerPlural: 'Танкеры',
    VesselWillBeDeleted: 'Судно {{mmsi}} будет удалено',
    Visibility: 'Видимость',
    Waves: 'Волны',
    Weather: 'Погода',
    Week: 'Неделя',
    WeightUnit: 'т',
    Wharve: 'Причалы',
    WharvesAnchor: 'Причалы, стоянки',
    WidthDimension: 'Ширина',
    Wind: 'Ветер',
    WindBarbs: 'Ветер (стрелки)',
    WindGust: 'Порывы ветра',
    WindSpeedUnit: 'м/c',
    WorldFleet: 'Мировой флот',
    ZoomInTipLabel: 'Приблизить',
    ZoomOutTipLabel: 'Отдалить',
  },
};

export default resourcesRu;
